import { useState } from 'react';
import {
    AccessDenied as AlliAccessDenied,
    AccessDeniedWithRequest,
} from '@agencypmg/alli-design-system';
import requestAccess from '../requestAccess';

const contentTitle = 'Access Denied';
const subtitle1 = 'You do not have access to this client.';

export default function AccessDenied({ currentUser, clientIdOrSlug }) {
    if (currentUser.type === 'pmg') {
        return (
            <AccessDeniedForPMGUser
                currentUser={currentUser}
                clientIdOrSlug={clientIdOrSlug}
            />
        );
    }

    return (
        <AlliAccessDenied
            title={contentTitle}
            subtitle={`You do not have access to ${clientIdOrSlug}.`}
            subtitle2="Please contact your account manager for access."
        />
    );
}

function AccessDeniedForPMGUser({ currentUser, clientIdOrSlug }) {
    const [submitted, setSubmitted] = useState(false);
    const onSubmit = async reason => {
        await requestAccess(clientIdOrSlug, currentUser.email, reason);
        setSubmitted(true);
    };

    return (
        <AccessDeniedWithRequest
            title={contentTitle}
            subtitle={`You do not have access to ${clientIdOrSlug}.`}
            subtitle2={
                submitted
                    ? 'Your access request has been submitted!'
                    : 'Need access? Submit a request below.'
            }
            onSubmit={onSubmit}
            formDisabled={submitted}
        />
    );
}
